export default __webpack_public_path__ + "static/media/ANEXO-I-CONVENIO-CAIXAxOAB-Declaracao-do-Advogado-beneficiario-cliente-do-advogado-1.3f99b337.doc";